//LIBRARIES
import React from 'react';
import { Field, FormSection } from 'redux-form';
import { TextField, DatePicker, SelectField } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

//COMPONENTS
import Header from 'components/shared/Header';
import AddressAutocomplete from 'components/shared/addressAutocomplete';

//HELPERS
import * as validator from 'helpers/Validator';
import * as format from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';

//CONSTANTS
import { CANADIAN_PROVINCES, USA_STATES } from 'constants/address.constants';
import { SALARY_RANGES } from 'constants/salaryranges.constants';

class WorkDetails extends React.Component {
  state = {
    states_or_provinces: null,
    currentCountry: getTranslatedString('country.CA'),
  };

  /**
   * Render province/state dropdown items base on country
   * @function renderDropdownList
   */
  renderDropdownList = () => {
    const { currentCountry } = this.state;
    let dropdownList = CANADIAN_PROVINCES.map((province) => {
      return <MenuItem value={province} primaryText={province} />;
    });

    if (isEqual(currentCountry, 'United States')) {
      dropdownList = USA_STATES.map((state) => {
        return <MenuItem value={state} primaryText={state} />;
      });
    }

    return dropdownList;
  };

  /**
   * update country state when autocomplete is selected
   * @function getAddressFromAutoComplete
   * @param { address } string - passed down from autocomplete
   */
  getAddressFromAutoComplete = (address) => {
    if (!isEmpty(address)) {
      this.setState({ currentCountry: address.country });
    }
  };

  addToAddressFields = (street, city, province, country, post_code) => {
    this.props.change('employment.company_street', street);
    this.props.change('employment.company_city', city);
    this.props.change('employment.company_province', province);
    this.props.change('employment.company_country', country);
    this.props.change('employment.company_postal_code', post_code);
  };

  render() {
    return (
      <FormSection name="employment">
        <div id="top" style={{ marginTop: '50px' }}>
          <Header name="Current Employment" />
          <div className="row" style={{ marginBottom: '70px' }}>
            <div className="row">
              <div className="row" style={{ marginBottom: '20px' }}>
                <div className="col-sm-6" style={{ textAlign: 'center' }}>
                  <Field
                    name="occupation"
                    type="text"
                    component={TextField}
                    floatingLabelText="Occupation"
                    style={{
                      marginTop: '-15px',
                      fontSize: '14px',
                      width: '100%',
                    }}
                    errorStyle={{ fontSize: '14px' }}
                    validate={[validator.required]}
                  />
                </div>
                <div className="col-sm-6" style={{ textAlign: 'center' }}>
                  <Field
                    name="company_name"
                    type="text"
                    component={TextField}
                    floatingLabelText="Company Name"
                    style={{
                      marginTop: '-15px',
                      fontSize: '14px',
                      width: '100%',
                    }}
                    errorStyle={{ fontSize: '14px' }}
                    validate={[validator.required]}
                  />
                </div>
              </div>
              <h5
                style={{
                  textAlign: 'center',
                  marginBottom: '0px',
                  marginTop: '10px',
                  fontSize: '14px',
                }}
              >
                Company Address
              </h5>
              <div className="col-xs-8" style={{ textAlign: 'center', zIndex: '1000' }}>
                <AddressAutocomplete
                  addToRedux={this.addToAddressFields}
                  label={getTranslatedString('landlordPortal.vendors.street')}
                  name="company_street"
                  getAddressFromAutoComplete={this.getAddressFromAutoComplete}
                  style={{ fontSize: '14px', width: '100%', marginTop: '6px' }}
                  autoFocus={true}
                  id="addressFormCompany"
                  validate={[validator.required]}
                />
              </div>
              <div className="col-xs-4" style={{ textAlign: 'center', zIndex: '1000' }}>
                <Field
                  name="company_unit"
                  type="text"
                  component={TextField}
                  floatingLabelText="Unit"
                  style={{
                    marginTop: '-15px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name="company_city"
                  type="text"
                  component={TextField}
                  floatingLabelText="City"
                  style={{
                    marginTop: '-15px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                  errorStyle={{ fontSize: '14px' }}
                  validate={[validator.required]}
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name="company_country"
                  type="text"
                  component={TextField}
                  floatingLabelText="Country"
                  style={{
                    marginTop: '-15px',
                    fontSize: '14px',
                    textAlign: 'left',
                    width: '100%',
                  }}
                  errorStyle={{ fontSize: '14px' }}
                  validate={[validator.required]}
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name="company_postal_code"
                  type="text"
                  component={TextField}
                  floatingLabelText="Postal Code"
                  style={{
                    marginTop: '-15px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                  validate={[validator.required]}
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name="company_province"
                  component={SelectField}
                  floatingLabelText="Province"
                  style={{
                    marginTop: '-15px',
                    fontSize: '14px',
                    textAlign: 'left',
                    width: '100%',
                  }}
                  errorStyle={{ fontSize: '14px' }}
                  validate={[validator.required]}
                >
                  {this.renderDropdownList()}
                </Field>
              </div>
            </div>

            <div className="row" style={{ marginTop: '20px' }}>
              <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '15px' }}>
                <Field
                  name="yearly_salary"
                  component={SelectField}
                  hintText={getTranslatedString('yearlyIncome')}
                  style={{
                    marginTop: '-15px',
                    fontSize: '14px',
                    textAlign: 'left',
                    width: '100%',
                  }}
                  errorStyle={{ fontSize: '14px' }}
                  validate={[validator.required]}
                >
                  {SALARY_RANGES.map((range) => (
                    <MenuItem value={range.value} primaryText={range.primaryText} />
                  ))}
                </Field>
              </div>

              <div className="col-sm-6" style={{ textAlign: 'center', marginTop: '10px' }}>
                <Field
                  name="start_date"
                  component={DatePicker}
                  openToYearSelection={true}
                  hintText="Employment Start Date"
                  maxDate={new Date()}
                  style={{
                    marginTop: '-15px',
                    fontSize: '14px',
                    width: '100%',
                  }}
                  errorStyle={{ fontSize: '14px' }}
                  formatDate={format.reformatDate}
                  autoOk={true}
                  hintStyle={{ fontSize: '14px' }}
                  validate={[validator.required]}
                />
              </div>
            </div>
          </div>
        </div>
      </FormSection>
    );
  }
}

export default WorkDetails;
